var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    enableBackground: "new 0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M176,456H80c-13.234,0-24-10.766-24-24v-96c0-13.234,10.766-24,24-24h96c13.234,0,24,10.766,24,24v96   C200,445.234,189.234,456,176,456z M80,328c-4.411,0-8,3.589-8,8v96c0,4.411,3.589,8,8,8h96c4.411,0,8-3.589,8-8v-96   c0-4.411-3.589-8-8-8H80z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M432,200h-96c-13.234,0-24-10.766-24-24V80c0-13.234,10.766-24,24-24h96c13.234,0,24,10.766,24,24v96   C456,189.234,445.234,200,432,200z M336,72c-4.411,0-8,3.589-8,8v96c0,4.411,3.589,8,8,8h96c4.411,0,8-3.589,8-8V80   c0-4.411-3.589-8-8-8H336z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M224,392v-16c0.021,0,6.611-0.112,12.828-3.363C244.346,368.707,248,361.957,248,352V160   c0-16.085,7.253-28.571,20.422-35.155C277.839,120.136,286.988,120,288,120l0.044,16c-0.066,0-6.655,0.112-12.873,3.363   C267.654,143.293,264,150.043,264,160v192c0,16.085-7.253,28.571-20.422,35.155C234.161,391.864,225.012,392,224,392z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b0c70c3a011509374144f3e872f5dadd.svg";
export { ForwardRef as ReactComponent };